<template>
    <div>
        <v-container justify-start>
            <v-layout
                v-bind="{
                    column: $vuetify.breakpoint.xsOnly,
                    row: $vuetify.breakpoint.smAndUp
                }"
                wrap
                align-content-start
                justify-start
            >
                <v-flex shrink>
                    <div class="title mb-2 mr-2">
                        Edit Player Position
                    </div>
                </v-flex>
                <v-divider vertical class="hidden-xs-only mr-2"></v-divider>
                <v-flex align-self-start>
                    <v-breadcrumbs divider=">" style="display:inline; padding-left: 0;">
                        <v-breadcrumbs-item style="" to="/admin" v-bind:exact="exact">Administration</v-breadcrumbs-item>
                        <v-breadcrumbs-item style="" to="/admin/players_positions" v-bind:exact="exact">Players Positions</v-breadcrumbs-item>
                        <v-breadcrumbs-item style disabled to="/admin/players_positions/edit" v-bind:exact="exact">Edit Player Position</v-breadcrumbs-item>
                    </v-breadcrumbs>
                </v-flex>
            </v-layout>
            <v-divider></v-divider>
        </v-container>
        <v-container grid-list-md>
            <v-layout row wrap justify-start>
                <v-flex xs12 sm6>
                    <v-card>
                        <v-card-text>
                            <v-form ref="form" v-model="valid">
                                <v-text-field
                                    v-model="season.season"
                                    label="Season"
                                    readonly
                                ></v-text-field>
                                <v-text-field
                                    v-model="player"
                                    label="Player"
                                    readonly
                                ></v-text-field>
                                <v-select
                                    v-model="selected_position"
                                    v-bind:items="positions"
                                    label="Position"
                                ></v-select>
                                <v-text-field
                                    v-model="player_number"
                                    v-bind:items="positions"
                                    label="Number"
                                    mask="##"
                                ></v-text-field>
                                <v-checkbox
                                    label="Spare"
                                    v-model="isSpare"
                                    type="checkbox"
                                ></v-checkbox>
                                <v-checkbox
                                    label="Manager"
                                    v-model="isManager"
                                    type="checkbox"
                                ></v-checkbox>
                            </v-form>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions>
                            <v-btn
                                flat
                                color="primary"
                                v-bind:disabled="!valid"
                                v-on:keyup.enter="submit"
                                v-on:click="submit"
                                data-cy="signinSubmitBtn"
                            >Update Player Position</v-btn>
                        </v-card-actions>
                    </v-card>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>

export default {
    name: 'AdminPlayersPositionsEdit',
    props: ['id'],
    data() {
        return {
            exact: true,
            valid: false,
            season: '',
            player: '',
            selected_position: '',
            player_number: null,
            isManager: false,
            isSpare: false
        }
    },
    mounted() {
        let player_position = this.$store.getters.getPlayerPositionById(this.id)

        this.season = this.$store.getters.getSeasonById(player_position.season_id)
        this.player = this.$store.getters.getPlayerFullNameById(player_position.player_id)
        this.selected_position = player_position.position
        this.player_number = player_position.number

        if (player_position.hasOwnProperty('manager')) {
            if (player_position.manager) {
                this.isManager = true
            }
            else {
                this.isManager = false
            }
        }
        else {
            this.isManager = false
        }

        if (player_position.hasOwnProperty('spare')) {
            if (player_position.spare) {
                this.isSpare = true
            }
            else {
                this.isSpare = false
            }
        }
        else {
            this.isSpare = false
        }
    },
    methods: {
        submit() {
            if (this.$refs.form.validate()) {
                this.$store.dispatch('updatePlayerPosition', {
                    id: this.id,
                    position: this.selected_position,
                    number: this.player_number,
                    manager: this.isManager,
                    spare: this.isSpare
                })
            }
        }
    },
    computed: {
        positions() {
            return this.$store.state.positions
        }
    }
}
</script>

<style scoped></style>
